import { render, staticRenderFns } from "./threshold-min-max.vue?vue&type=template&id=20f3a635&"
import script from "./threshold-min-max.vue?vue&type=script&lang=js&"
export * from "./threshold-min-max.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports